module.exports = __webpack_public_path__ + "static/img/son4.d96feb32.jpg";